var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5902 17.1429H2.11804C0.926641 17.1429 0 18.0804 0 19.2857V27.8571C0 29.0625 0.926641 30 2.11804 30H10.5902C11.7816 30 12.7082 29.0625 12.7082 27.8571V19.2857C12.7082 18.0804 11.7816 17.1429 10.5902 17.1429ZM8.47215 25.7143H4.23607V21.4286H8.47215V25.7143ZM10.5902 0H2.11804C0.926641 0 0 0.9375 0 2.14286V10.7143C0 11.9196 0.926641 12.8571 2.11804 12.8571H10.5902C11.7816 12.8571 12.7082 11.9196 12.7082 10.7143V2.14286C12.7082 0.9375 11.7816 0 10.5902 0ZM8.47215 8.57143H4.23607V4.28571H8.47215V8.57143ZM27.5345 0H19.0623C17.8709 0 16.9443 0.9375 16.9443 2.14286V10.7143C16.9443 11.9196 17.8709 12.8571 19.0623 12.8571H27.5345C28.7259 12.8571 29.6525 11.9196 29.6525 10.7143V2.14286C29.6525 0.9375 28.7259 0 27.5345 0ZM25.4164 8.57143H21.1804V4.28571H25.4164V8.57143Z",
    fill: "#3D0E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2982 30H25.4162V27.8571H23.2982V30ZM27.5343 17.1429V19.2857H23.2982V17.1429H16.9441V30H21.1802V23.5714H23.2982V25.7143H29.6523V17.1429H27.5343ZM27.5343 30H29.6523V27.8571H27.5343V30Z",
    fill: "#FFB6BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcQrCode);
export default __webpack_public_path__ + "static/media/ic_qr_code.cae4a67f328b9af2bb4b1dde78332e1c.svg";
export { ForwardRef as ReactComponent };